var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.$style.button, ( _obj = {}, _obj[_vm.$style.waiting] = _vm.waiting, _obj )],attrs:{"disabled":_vm.disabled || _vm.waiting},on:{"click":_vm.handleClick}},[_vm._t("default"),_vm._v(" "),(_vm.waiting)?_c('div',{class:_vm.$style.indicator},[_c('Spinner',{attrs:{"alt-color":_vm.useLightSpinner,"size":16}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }